import { Components } from '@mui/material'

const MuiButton: Components['MuiButton'] = {
  defaultProps: {
    size: 'large',
    disableElevation: true,
  },
  styleOverrides: {
    root: {
      borderRadius: '3px',
      boxShadow: 'none',
      textTransform: 'none',
      fontWeight: 600,
      '&:hover': {
        boxShadow: 'none',
      },
      variants: [
        {
          props: { variant: 'contained' },
          style: ({ theme }) => ({
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.primary.contrastText,
            '&:hover': {
              backgroundColor: theme.palette.primary.dark,
            },
          }),
        },
        {
          props: { variant: 'contained', color: 'error' },
          style: ({ theme }) => ({
            backgroundColor: theme.palette.error.main,
            '&:hover': {
              backgroundColor: theme.palette.error.dark,
            },
          }),
        },
        {
          props: { variant: 'contained', color: 'info' },
          style: ({ theme }) => ({
            backgroundColor: theme.palette.grey[100],
            color: theme.palette.grey[500],
            '&:hover': {
              backgroundColor: theme.palette.grey[200],
            },
          }),
        },
        {
          props: { variant: 'outlined' },
          style: ({ theme }) => ({
            borderColor: theme.palette.divider,
            color: theme.palette.text.primary,
            '&:hover': {
              backgroundColor: theme.palette.grey[100],
              borderColor: theme.palette.text.secondary,
            },
          }),
        },
        {
          props: { variant: 'outlined', color: 'error' },
          style: ({ theme }) => ({
            borderColor: theme.palette.error.main,
            '&:hover': {
              backgroundColor: theme.palette.error[50],
            },
          }),
        },
        {
          props: { variant: 'outlined', color: 'info' },
          style: ({ theme }) => ({
            borderColor: theme.palette.grey[300],
            color: theme.palette.text.primary,
            '&:hover': {
              backgroundColor: theme.palette.grey[100],
              borderColor: theme.palette.grey[300],
            },
          }),
        },
        {
          props: { variant: 'text' },
          style: ({ theme }) => ({
            color: theme.palette.primary.main,
            '&:hover': {
              backgroundColor: theme.palette.grey[100],
            },
          }),
        },
      ],
    },
  },
}

export default MuiButton
